<template>
  <div id="main" :class="currentFont" :style="{backgroundImage:'url('+require('../../public'+backgroundImg)+')'}" @touchstart.capture="touchStart"  @touchend.capture="touchEnd"  @mousewheel="mouseWheel">
       <div class="pos-absolute full-width">
      <div class="full-width bg-color" id="nav-top">
            <div>
  
                <div class="py-16" v-if="isMobileDevice"></div>
                <div class="py-6" v-if="!isMobileDevice"></div>
                <div  class="full-width pos-relative">
                    <img class="full-width logo-bg fade-in-ani"  :class="[{'logo-bg-mb':isMobileDevice}]" src="/Images/bp_lp_top_bg.png" alt="">
                    <img class="logo-mb  fade-in-ani-delay"  src="/Images/dp_lp_pc_top_logo.png" alt="">
                </div>
                <br>
                <div class="top-right" v-if="isMobileDevice">
                  <div class="lg-div">
                          <div class="zq-drop-list-new" >
                              <span  @click="showLg=true">{{lgs[lgIndex].name}}</span>
                              <div class="triangle-down"></div>
                              <ul id='lgTarget' v-show="showLg">
                                <li :class="{'chossLi':index==lgIndex}" v-for="(item, index) in lgs" :key="index" @click="onClickLg(index)">{{item.name}}</li>
                              </ul> 
                          </div>
                       </div>
                    <img @click="showNav" src="/Images/bp_lp_hamburger_menu_1.png" alt="" >
                </div>
                <div class="top-right" v-if="!isMobileDevice" :style="isMobileDevice?'':'right:40px'">
                  <div class="lg-div">
                          <div class="zq-drop-list-new" >
                              <span @click="showLg=true">{{lgs[lgIndex].name}}</span>
                              <div class="triangle-down"></div>
                              <ul id='lgTarget' v-show="showLg">
                                <li :class="{'chossLi':index==lgIndex}" v-for="(item, index) in lgs" :key="index" @click="onClickLg(index)">{{item.name}}</li>
                              </ul> 
                          </div>
                       </div>
                </div>
              </div>
            <div class="py-4" ></div>
              <div v-if="isMobileDevice" >
                <img style="width:80%;margin:auto;opacity:0" class="max-width fade-in-ani-delay2"  :src="titleUrl" alt="">

              
            
              </div>
              <div  v-if="!isMobileDevice">
                     <img style="width:50%;margin:auto;opacity:0;" class="max-width fade-in-ani-delay2"  :src="titleUrl" alt="">
              </div>
               
        </div>
        <div  class="full-width bg-color " >

            <div class="py-8" ></div>
            <p class="p-desc opacity-0" :class="[{'mb-font-desc':isMobileDevice},{'fade-in-ani':isScrolled}]" v-html="isMobileDevice?$t('LP.top_desc_mb'):$t('LP.top_desc_pc')">
    
            </p>

            <div class="py-16" ></div>
        </div>
        <div class="empty" :style="{height:winHeight}"></div>
        <div id="nav-message"  class="full-width bg-color-85" >
            <div class="py-4" ></div>
                <div class="py-4" v-if="!isMobileDevice"></div>
            <h2 class=" font-title letter-spacing-title" :class="[currentBoldFont,{'mb-font-title':isMobileDevice}]"  >{{$t('LP.msg.msg_title')}}</h2>
            <div class="py-2 " ></div>
                <div class="py-4" v-if="!isMobileDevice"></div>
             <p class="p-desc" style="text-align:center" :class="[{'mb-font-desc-s':isMobileDevice}]" v-html="isMobileDevice?$t('LP.msg.msg_desc_mb'):$t('LP.msg.msg_desc_pc')">
                
            </p>
            <div class="py-2" ></div>
            <p class="p-desc max-width" style="text-align:center" :class="[{'mb-font-desc-s':isMobileDevice}]">{{$t('LP.msg.msg_foot')}}
            </p>
            <div class="py-8" ></div>
                <div class="py-2" v-if="!isMobileDevice"></div>
        </div>

        <div id="element_bg_A"  class="empty" :style="{height:winHeight}"></div>
          <div id="nav-artist"  class="full-width bg-color" >
            <div class="py-4" ></div>
                <div class="py-4" v-if="!isMobileDevice"></div>
            <h2 class="font-title letter-spacing-title" :class="[{'mb-font-title':isMobileDevice}]" >{{$t('LP.art.title1')}}</h2>
            <div class="py-2" ></div>
            <div v-if="isMobileDevice">
            <img class="full-width" src="Images/RM.jpg" alt="">
            <div class="py-2" ></div>
              <h3 class=" font-desc max-width text-left" style="width:90%" :class="[{'mb-font-desc':isMobileDevice}]">{{$t('LP.art.title3')}}</h3>
            <div class="down-div max-width">
              
              <h3 class="text-left " style="font-size:1.25rem" >{{$t('LP.art.title2')}}</h3>
              <img src="Images/bp_lp_yajirushi_1.png" alt="" v-if="!isDown" @click="onClickDown">

              <img src="Images/bp_lp_yajirushi_2.png" alt=""  v-if="isDown" @click="onClickDown">
            </div>
                 <div class="py-2" ></div>
             <p  v-if="!isDown" class="p-desc font-desc max-width" style="text-align:left"  :class="[{'mb-font-desc':isMobileDevice}]">{{$t('LP.art.desc1')}}
            </p>
              <p  v-if="isDown" class="p-desc font-desc max-width" style="text-align:left"  :class="[{'mb-font-desc':isMobileDevice}]">{{$t('LP.art.desc2')}}
            </p>
            </div>
               <div class="py-6" v-if="!isMobileDevice" ></div>
             <div v-if="!isMobileDevice" class="art-div">
               <div style="width:38%">
                  <img class="full-width" src="Images/RM.jpg" alt="" style="margin-top:0.7rem">
                  <div class="py-2" ></div>
                    <h3 class=" text-left max-width"  style="margin-left:0;width:90%">{{$t('LP.art.title3')}}</h3>
                    <h3 class=" text-left "  style="margin-left:0;font-size:1.5rem">{{$t('LP.art.title2')}}</h3>
                  </div>
               <div style="width:62%">

              <p class="p-desc  max-width" style="text-align:left;font-size:1rem;line-height:2.2rem;letter-spacing: 2px;"  >{{$t('LP.art.desc2')}}
            </p>
               </div>
          
            </div>
            

            <div class="py-8" ></div>
                <div class="py-2" v-if="!isMobileDevice"></div>
        </div>

        <div id="element_bg_B" class="empty" :style="{height:winHeight}"></div>
        <div id="nav-expenrise"  class="full-width bg-color pos-relative bg-img" :style="[{'background-size':isMobileDevice?'100%':'1200px'},{'background-position':isMobileDevice?'0% 25%':'50% 10%'},{backgroundImage:isMobileDevice?'url('+require('../../public/Images/bp_lp_watage_bg.jpg')+')':'url('+require('../../public/Images/dp_lp_pc_experience_bg.jpg')+')'}]">
            <div class="max-width" style="margin:auto">
              <div class="py-4"></div>  

                <div class="py-4" v-if="!isMobileDevice"></div>
            <h2 class="font-title letter-spacing-title" :class="[{'mb-font-title':isMobileDevice}]">{{$t('LP.experrience.text_title1')}}</h2>
             <div class="py-2"></div>
                <div class="py-2" v-if="!isMobileDevice"></div>
            <h3 class="font-desc" :style="isMobileDevice?'':'font-size:1.125rem;letter-spacing:2px'" :class="[{'mb-font-desc':isMobileDevice}]">{{isMobileDevice?$t('LP.experrience.text_title2_mb'):$t('LP.experrience.text_title2_pc')}}</h3> 

            <div v-if="needHide" class="py-12"></div>
            <div v-if="!needHide" class="py-16"></div>
            <div class="input-btn" :style="{width:isMobileDevice?'45%':'30%'}" @click="onClickPlay" >
              <img src="Images/dp_lp_pc_experience_button.png" alt=" " >   
              <span class=" font-desc" style="width:100%"  :style="{'font-size':isMobileDevice?'1rem':'1.125rem'}"  :class="[{'mb-font-desc':isMobileDevice}]" >{{$t('LP.experrience.text_btn')}}</span>
              </div>
            <div v-if="needHide" class="py-6"></div>
                  <div  :class="isMobileDevice?'py-10':'py-10'"></div>    
              <p  v-if="!needHide" class=" font-desc" :style="isMobileDevice?'':'font-size:1.125rem;line-height:2rem'" :class="[{'mb-font-desc':isMobileDevice}]">{{$t('LP.experrience.text_desc')}}</p>
 
              <div v-if="!needHide" class="input-btn" :style="{width:isMobileDevice?'30%':'20%'}" @click="goAnchor('nav-contribution')" >
              <img src="Images/dp_lp_pc_experience_button.png" alt=" " >   
              <span class=" font-desc"  style="width:100%;top:49%" :style="{'font-size':isMobileDevice?'1rem':'1.2rem'}" :class="[{'mb-font-desc':isMobileDevice}]" >{{$t('LP.experrience.text_link')}}</span>
              </div>
                <div class="py-8"></div> 
            </div>
            
        </div>



        <div id="element_bg_B1" class="empty" :style="{height:winHeight}"></div>
      

        <div id="nav-place" class="div-scroll full-width bg-color"   >
            <div class="py-4"></div>  

                <div class="py-4" v-if="!isMobileDevice"></div>
            <h2 class="font-title letter-spacing-title" :class="[{'mb-font-title':isMobileDevice}]">{{$t('LP.placeText.title')}}</h2>
             <div class="py-2"></div>
                <div class="py-1" v-if="!isMobileDevice"></div>
            <h3 class="font-desc p-desc" :style="isMobileDevice?'':'font-size:1.125rem;letter-spacing:2px'" :class="[{'mb-font-desc':isMobileDevice}]">{{isMobileDevice?$t('LP.placeText.desc_mb'):$t('LP.placeText.desc_pc')}}</h3> 
        
                <div class="py-1" v-if="!isMobileDevice"></div>
                  <div class="py-2"></div>
                  <div  class=" place-div-mb full-width" style="position: relative;" v-if="isMobileDevice" :class="[{'effect-blur':placeClicked}]">
                         <!-- <div ref="placeScroll" class="full-width  placeWrapper" >
                      <div ref="placeScrollContent" class="tags" >
                        <div class="tag"
                          v-for="({ name, time, image,tips,url_msg,url }, i) in $t('LP.place')"  :key="i"
                        >
                                                      <img :src="image" alt="">
                                                      <h4 class=" slide-item-p " :class="currentBoldFont">{{ name }}</h4>
                                                      <p class=" slide-item-p" :class="currentBoldFont">{{ time }}</p>
                                                      
                                                      <p class="slide-item-p" :class="currentBoldFont">{{ tips }}</p>
                                                      <div class="input-btn"  style="width:120px;z-index:3"  @touchstart.capture="enterPlace"  @touchend.capture="onClickPlace(url)" v-if="url_msg">
                                                        <img src="Images/dp_lp_pc_hp_button.png" alt=" " >   
                                                        <span  style="top:40%;left=48%;width:100%;font-size:0.85rem"  :class="currentBoldFont">{{url_msg}}</span>
                                                      </div>
                        </div>
                         <div class="tag"
                          v-for="({ name, time, image ,tips,url_msg,url},j) in $t('LP.place')"  :key="'s'+j"
                        
                        >
                                                      <img :src="image" alt="">
                                                      <h4 class=" slide-item-p"  :class="currentBoldFont">{{ name }}</h4>
                                                      <p class="slide-item-p" :class="currentBoldFont">{{ time }}</p>        
                                                      <p class=" slide-item-p" :class="currentBoldFont">{{ tips }}</p>
                                                      <div class="input-btn"  style="width:120px;z-index:3"  @touchstart.capture="enterPlace" @touchend.capture="onClickPlace(url)" v-if="url_msg">
                                                        <img src="Images/dp_lp_pc_hp_button.png" alt=" " >   
                                                        <span  style="top:40%;left=48%;width:100%;font-size:0.85rem"  :class="currentBoldFont">{{url_msg}}</span>
                                                      </div>
                        </div>
                      </div>
                    </div>
                      <img class="button-prev " src="Images/icon_prev.png" @click="changeSlide(-1)">
                                            <img class="button-next" src="Images/icon_next.png" @click="changeSlide(1)"> -->
                                            <div class="place-div-item-mb" v-for="({ name_mb1, name_mb2, image_mb }, i) in $t('LP.place')"  :key="i">
                                                  <div class="slide-item-mb" @click="onClickPlaceIndex(i)" > 
                                                      <img :src="image_mb" alt="">
                                                      <h4 class="slide-item-p"  :class="currentBoldFont" style="font-size:0.8rem" >{{ name_mb1 }}</h4>
                                                      <h4 class="slide-item-p"  :class="currentBoldFont" style="font-size:0.8rem" >{{ name_mb2 }}</h4>
                                                    
                                                      </div>
                                                      </div>
                  </div>
                 
               
              <div class="place-div" v-if="!isMobileDevice" >
                 <div class="place-div-item" v-for="({ name, time, image ,tips,url_msg,url }, i) in $t('LP.place')"  :key="i">
                                                  <div class="slide-item"> 
                                                      <img :src="image" alt="">
                                                      <h4 class="slide-item-p"  :class="currentBoldFont" style="font-size:0.9rem" >{{ name }}</h4>
                                                      <p class="slide-item-p" :class="currentBoldFont">{{ time }}</p>
                                                      <p class="slide-item-p" :class="currentBoldFont">{{ tips }}</p>
                                                      <div class="input-btn"  style="width:120px"   @click="onClickPlace(url)" v-if="url_msg">
                                                        <img src="Images/dp_lp_pc_hp_button.png" alt=" " >   
                                                        <span  style="top:40%;left:48%;width:100%;font-size:0.85rem"  :class="currentBoldFont">{{url_msg}}</span>
                                                      </div>
                                                      </div>
                                                      </div>
              </div>
         
                  <div class="py-8"></div>

        </div>
        <div id="element_bg_C"  class="empty" :style="{height:winHeight}"></div>
        <div id="nav-result"  class="full-width bg-color pos-relative bg-img" :style="{backgroundImage:isMobileDevice?'url('+require('../../public/Images/bp_lp_watage_bg.png')+')':'url('+require('../../public/Images/dp_lp_pc_counter_bg.jpg')+')'}">
            <div :class="isMobileDevice?'py-5':'py-10'"></div> 
            <h3 class="font-title" style="line-height: 2rem;"  :style="isMobileDevice?'font-size:2rem':'font-size:1.95rem'" :class="[{'mb-font-title':isMobileDevice}]">{{isMobileDevice?$t('LP.result.text_title1_mb'):$t('LP.result.text_title1_pc')}}</h3> 
            <div :class="isMobileDevice?'py-3':'py-4'"></div> 
            <p  class="font-desc" style="width:90%;margin:auto" :style="isMobileDevice?'':'font-size:1.125rem'" :class="[{'mb-font-desc':isMobileDevice}]">{{$t('LP.result.text_desc')}}</p> 
              <div :class="isMobileDevice?'py-2':'py-4'"></div> 
            <div class="num-div" >
              <div class="pos-relative">
                
                <img src="Images/bp_lp_counter.png" alt=" " >   
                <span :class="currentBoldFont" >{{totalNumber}}</span>
              </div>

              <!-- <div class="flower-count">
                  <img v-for="i in this.watageNum" :key="i" src="Images/watage_res/watage_res_19.gif" alt="" :style="'filter:hue-rotate('+(360*Math.random())+'deg)'">
                </div> -->
              </div>
              <div class="py-2"></div> 
              <div :style="isMobileDevice?'height:500px':'height:700px'"></div>
              <div id="flower-div" :style="isMobileDevice?'top:34%;height:800px':'top:33.9%;height:1000px'" >
                <img :src="watateResBgUrl" alt="" class="flower-gif" :style="isMobileDevice?'width:85%;top:55%':'width:60%;top:55%'">
               
              </div>
                <div class="py-8"></div> 

            <p class="font-title" :style="isMobileDevice?'font-size:1.5rem;line-height: 1.5rem;':'font-size:2.225rem;line-height: 2.25rem;'" :class="['font-Bold-en',{'mb-font-desc':isMobileDevice}]">{{$t('LP.result.text_title2')}}</p> 
                <div class="py-3"></div> 
                    <div class="div-scroll-name max-width"  @mousewheel="mouseWheelResult">
                   
                <scroller   ref="my_scroller"  refreshText=""  noDataText=''   :on-infinite="infinite"> 
                    <div class="box-x">
                              <div  v-for="(item, i) in playerNames"
                                :key="i"
                                class="box2">
                                <p :class="currentBoldFont">{{item.lastName? (item.firstName + " "+item.lastName) :item.firstName }}</p>
                                </div>
                    </div>
                    </scroller>
                </div>
                

                  <div class="py-8"></div> 
          </div>
          <div id="nav-contribution"  class="full-width bg-color-yellow pos-relative" v-if="!needHide"  :style="[{'background-size':'110%'},{'background-position':'0% 10%'},{backgroundImage:isMobileDevice?'url('+require('../../public/Images/newbg.png')+')':'url('+require('../../public/Images/newbg_pc.png')+')'}]">
            <div class="py-8"></div> <div class="py-4" v-if="isMobileDevice"></div><div class="py-8" v-if="!isMobileDevice"></div>
            <h2 class="font-title" style="font-size:20px" :class="[{'mb-font-title':isMobileDevice}]">{{$t('LP.ctr.title1')}}</h2> 
            <h3 class=" font-desc"  style="font-size:20px"  :class="[{'mb-font-desc':isMobileDevice}]">{{$t('LP.ctr.title2')}}</h3> 
            <div class="py-4"></div> 
            <p  class="p-desc font-desc"  :style="{'font-size':isMobileDevice?'0.85rem':'1.125rem'}" :class="[{'mb-font-desc-s':isMobileDevice}]" v-html="isMobileDevice?$t('LP.ctr.desc1_mb'):$t('LP.ctr.desc1_pc')" ></p> 
            <div class="py-4"></div> 
              <div class="py-4" v-if="lgIndex==1"></div> 
              <p  class="p-desc font-desc" style="line-height:1.25rem" :style="{'font-size':isMobileDevice?'0.7rem':'1rem'}" :class="[{'mb-font-desc-s':isMobileDevice}]" v-html="$t('LP.ctr.desc2')" ></p> 
         
              <div class="py-4"></div> 
            <div style="display:flex;justify-content: space-between;width:90%;max-width:500px;margin:auto">
              <div class="radio-div" v-for="(item,i) in $t('LP.ctr.pay_urls')" :key="i"  :style="{'font-size':isMobileDevice?'0.7rem':'1.125rem'}">
                    <input type="radio"  :value="i" v-model="moneyType">
                    <span :class="currentFont" >{{item.name}}</span>
              </div>
              
              
              <!-- <input type="radio" value="1" v-model="moneyType">100
              <input type="radio" value="2" v-model="moneyType">200 -->
            </div>
                
                <div style="display:flex;width:90%;max-width:500px;margin:auto;margin-top:10px;justify-content: space-between;"  :style="{'font-size':isMobileDevice?'0.7rem':'1.125rem'}">
                  <div class="radio-div" style="margin:auto;width:50%;text-align: left;display: flex;">
                      <input type="radio" value=4 v-model="moneyType">
                      <span :class="currentFont" >{{$t('LP.ctr.input_tips')}}</span>
                    </div>
                    <div class="input-frame pos-relative" style="width:50%;margin:auto;display: flex;justify-content: flex-end;">  
                        <span :class="currentFont" style="margin:auto 5px;">{{$t('LP.ctr.price_type')}}</span>
                        <input class="form-input font-en"  :disabled="moneyType!=4" v-model="priceNumber" type="text" @change="formatValue" placeholder="" maxlength="10" minlength="1" />
                    
                    </div>   
                </div>
               <div class="py-4"></div> 
              <div class="py-4" v-if="lgIndex==1"></div> 
                    <div :style="{'font-size':isMobileDevice?'0.7rem':'1rem'}" style="line-height: 1.25rem;color:rgb(70, 70, 70);width:100%;margin:auto;word-wrap:break-word;text-align: center;white-space: pre-wrap;">
                      <div :class="currentFont" ><span>{{$t('LP.ctr.safari_tips1')}}</span><span style="cursor: pointer;text-decoration: none;border-bottom: 2px solid rgb(70, 70, 70);" @click="()=>{this.showSafariTips=true;}">{{$t('LP.ctr.safari_tips2')}}</span><span>{{$t('LP.ctr.safari_tips3')}}</span></div>
                      <div :class="currentFont" :style="{'margin':isMobileDevice?'0.2rem':'10px'}">{{$t('LP.ctr.min_money_tips')}}</div>
                      <a style="color:rgb(70, 70, 70);cursor: pointer;text-decoration: none;border-bottom: 2px solid rgb(70, 70, 70);display:inline-block;" :class="currentFont" :href="lgIndex == 0?'./jp_breathbless.html':'./en_breathbless.html'" target="_blank">{{$t('LP.ctr.law_tips')}}</a>
                    </div>
               <div class="py-8"></div> 
              <div class="input-btn" style="width: 150px;" @click="onClickCtr1">
                <img src="Images/new_button.png" alt=" " > 
                <span   style="top:40%;left:50%;white-space: nowrap;"  :style="{'font-size':isMobileDevice?'0.85rem':'1rem'}" :class="[currentBoldFont,{'mb-font-desc-s':isMobileDevice}]">{{$t('LP.ctr.btn1')}}</span>
              </div>
                <!-- <div class="py-2"></div> 

            <p class="p-desc font-desc "  :class="[{'mb-font-desc-s':isMobileDevice}]">{{$t('LP.ctr.desc2')}}</p> 
            
                <div class="py-2"></div> 

              <div class="input-btn" style="width:70%" @click="onClickCtr2">
                <img src="Images/bp_lp_button_shien.png" alt=" " >   
                <span class="font-Bold-jp" style="width:100%;top:42%;left=48%;font-size:1rem" :class="[currentBoldFont,{'mb-font-desc-s':isMobileDevice}]" > {{$t('LP.ctr.btn2')}}</span>
              </div> -->
                  <div class="py-8"></div> 
          </div>
          <div id="nav-supporters"  class="full-width bg-color pos-relative" >
            <div class="py-8"></div>
            <h2 class="font-title" :style="isMobileDevice?'':'font-size:2.225rem'"  :class="[{'mb-font-title':isMobileDevice}]">{{$t('LP.supportTitle')}}</h2> 
            <div class="py-2"></div> 
                <div class="py-2" v-if="!isMobileDevice"></div>
             <div class="supporters-div">
                    <div  v-for="({ logo }, i) in $t('LP.supporters')"
                                :key="i"
                                class="supporters-item"  :style="{'margin':isMobileDevice?'':'0 5% 0 5%'}">
                                <v-img class="support-img" :src="logo"></v-img>
                                </div>
                  </div>

                <div class="py-4" v-if="!isMobileDevice"></div>
            <div id="nav-contact" class="py-8"></div> 
              <div class="input-btn"  style="width:80%" @click="onClickContact">
                <img src="Images/bp_lp_button_contact.png" alt=" " >   
                <span class=" font-desc" style="top:42%;left:48%;width:100%;letter-spacing:0.2rem"  :class="[currentBoldFont,{'mb-font-desc':isMobileDevice}]">{{$t('LP.contactTitle')}}</span>
              </div>
              <div class="py-8"></div> 

              <img style="width:70%;max-width:250px" src="Images/bp_lp_nakedlogo.png" alt="">
              <div class="py-4"></div> 

               <div class="icon-div" style="width:40%">
                    <a href="https://www.facebook.com/NAKEDINC.official/" target="_blank" >
                      <img src="Images/bp_lp_sns_fb.png" alt="">
                    </a>
                    <a href="https://www.instagram.com/naked_inc/" target="_blank" >
                      <img src="Images/bp_lp_sns_insta.png" alt="">
                    </a>
                    <a href="https://page.line.me/018eukgm?openQrModal=true" target="_blank" >
                      <img src="Images/bp_lp_sns_line.png" alt="">
                    </a>
                </div>

              <div class="py-4"></div> 
             <span class="font-Bold-en footer">&copy; {{ new Date().getFullYear() }} NAKED, INC.</span>
              <div class="py-4"></div> 
          </div>

          <div class="pop" :class="[{'navmoveback':navstatus==2},{'navmove':navstatus==1}]" >
            
              <div class="py-4"></div> 
                  <img class="nav-close" @click="closeNav" src="Images/bp_lp_hamburger_menu_2.png" alt="">
              <div class="py-2"></div> 
                  <img class="nav-logo" src="Images/dp_logo_w.png" alt="">
              <div class="py-2"></div> 
              <ul class="nav-ul">
                <li  v-for="({ name,id }, i) in $t('LP.nav')"
                                :key="i"  @click="goAnchor(id)">
                  <p   :class="[{'mb-font-desc':isMobileDevice}]">{{name}}</p>
                </li>
              </ul>
              <div v-if="needHide" class="py-4"></div>
                <div class="icon-nav" >
                    <a href="https://www.facebook.com/NAKEDINC.official/" target="_blank" >
                      <img src="Images/bp_lp_sns_fb_w.png" alt="">
                    </a>
                    <a href="https://www.instagram.com/naked_inc/" target="_blank" >
                      <img src="Images/bp_lp_sns_insta_w.png" alt="">
                    </a>
                    <a href="https://page.line.me/018eukgm?openQrModal=true" target="_blank" >
                      <img src="Images/bp_lp_sns_line_w.png" alt="">
                    </a>
                </div>

              <div class="py-2"></div> 
             <span class="font-Bold-en footer" style='color:white'>&copy; {{ new Date().getFullYear() }} NAKED, INC.</span>
            </div>
                <div class="pop " style="background:#f8f7f2;left:0" v-if="showSafariTips" >
                  <a   @click="()=>{this.showSafariTips= false}"  style="position:absolute;left:20px;top:20px;cursor: pointer;" >
                      <img style="width:30px" src="Images/safari_close.png" alt="" >
                  </a>
                  <br><br><br>
                 <div style="font-size:0.9rem;width:90%;margin:auto;word-wrap:break-word;text-align: center;white-space: pre-wrap;" >
                   {{$t('LP.ctr.safari_setting_tips')}}
                 </div><br>
                      <img style="width:70%;max-width:400px"  :src="safariUrl" alt="" >
                </div>
                <div class="pop " style="background:#0000000F;left:0" v-if="placeClicked" >
                  <div :style="[{backgroundImage: 'url('+require('../../public/Images/popup.png')+')'}]" class="popupdiv">
                    <a   @click="()=>{this.placeClicked= false}"  style="position:absolute;right:20px;top:15px;cursor: pointer;" >
                      <img style="width:20px" src="Images/close.png" alt="" >
                  </a>
                  <img style="width:78%;margin-top: 35px;" :src="$t('LP.place')[ placeClickIndex ].image" alt="" >
             
                 <h4 class="slide-item-p"  :class="currentBoldFont" style="font-size:1rem;margin-top:15px" >{{$t('LP.place')[ placeClickIndex ].name}}</h4>
                                                      <p class="slide-item-p" :class="currentBoldFont">{{$t('LP.place')[ placeClickIndex ].time}}</p>
                                                      <p class="slide-item-p" :class="currentBoldFont" style="font-size:0.6rem;margin: 5px 0;" >{{$t('LP.place')[ placeClickIndex ].tips}}</p>
                                                      <div class="input-btn"  style="width:150px;"   @click="onClickPlace($t('LP.place')[ placeClickIndex ].url)" v-if=" $t('LP.place')[ placeClickIndex ].url_msg">
                                                        <img src="Images/shousai.png" alt=" " >   
                                                        <span  style="top:40%;left:48%;width:100%;font-size:0.85rem"  :class="currentBoldFont">{{$t('LP.place')[ placeClickIndex ].url_msg}}</span>
                                                      </div>
                                                      <div style="height:20px"></div>
                  </div>
                 
                  <br><br><br>
           
                </div>
       </div>
       
  </div>
</template>

<script>
import isMobile from "ismobilejs";
import BScroll from 'better-scroll';

import netMgr from "../network/netMgr.js"
var Watege = function(color,type,nameF,nameL,isPc){
            this.init(color,type,nameF,nameL,isPc);
  };
  Watege.prototype = {
              init : function(color,type,nameF,nameL,isPc){
                  this._top = 100*Math.random();
                  this._left = 100*Math.random();
                  this._scale = (isPc?50:30)+70*Math.random();
                  this._rotate = 180*Math.random();
                  this._move_h_speed = (0.5+Math.random()) *  (Math.random()>0.5?1:-1);
                  this._move_v_speed = Math.random()<0.5?(0.5+1*Math.random()):-(0.5+1*Math.random());
                  this._scale_speed = Math.random();
                  this._rotate_speed =Math.random()>0.5?Math.random():-Math.random();
                  this._opacity = 0; 
                  
                  this.img = document.createElement('div');
                  this.img.style.position = "absolute";
                  this.img.style.filter = "hue-rotate("+color+"deg)"
                  this.img.style.opacity= 0;
                  // this.img.style.fontSize = "2rem";
                  this.img.style.top = this._top+"%";
                  this.img.style.left = this._left+"%";
                  this.img.style.width = this._scale+"px";
              
                  this.img.style.transform = "translate(-50%,-50%) rotate("+this._rotate+"deg)";
                  
                  this.imgPic = document.createElement('img');
                  this.imgPic.src = "Images/watage/watage_"+type+'.png';
                  this.imgPic.style.width = '100%';
                  this.img.appendChild(this.imgPic);

                  this.imgDiv = document.createElement('div');
                  this.imgDiv.style.position = "absolute";
                  this.imgDiv.style.fontSize = Math.ceil(this._scale/5)+"px";
                  this.imgDiv.style.width = '100%';
                  this.imgDiv.style.top = "50%";
                  this.imgDiv.style.left = "50%";
                  this.imgDiv.style.transform = "translate(-50%,-50%)";
                  this.imgP1 = document.createElement('p');
                  this.imgP1.appendChild(document.createTextNode(nameF));
                  this.imgP1.classList.add("font-Bold-en");
                  this.imgP1.style = "text-align:center;margin:0;line-height:1;font-family:'sofia-pro', sans-serif;font-weight: 700;font-style: normal;";
                  this.imgP2 = document.createElement('p');
                  this.imgP2.appendChild(document.createTextNode(nameL));
                  this.imgP2.style = "text-align:center;margin:0;line-height:1;font-family:'sofia-pro', sans-serif;font-weight: 700;font-style: normal;";
                  this.imgDiv.appendChild(this.imgP1);
                  this.imgDiv.appendChild(this.imgP2);
                  this.img.appendChild(this.imgDiv);
                  document.getElementById('flower-div').appendChild( this.img );
                  var self = this;
                  requestAnimationFrame(function fn(){
                      if(self._top>120||self._top < -20 || self._left> 120 || self._left< -20){
                            self._top = 100*Math.random();
                            self._opacity = 0;
                            self._left = 100*Math.random();
                      }
                      self._top += self._move_h_speed/20 ;
                      self._left += self._move_v_speed/20;
                      self._rotate += self._rotate_speed/2;
                      if(self._opacity<1)
                        self._opacity += 0.1;
                      
                      self.img.style.opacity = self._opacity;
                      self.img.style.top = Math.round(self._top*100)/100+"%";
                      self.img.style.left = Math.round(self._left*100)/100+"%";
                      self.img.style.transform = "translate(-50%,-50%) rotate("+ Math.round(self._rotate*100)/100+"deg)";
                      requestAnimationFrame(fn);
                  });
              },
              destroyFunc:function(){
                if(document.getElementById('flower-div'))
                 document.getElementById('flower-div').removeChild( this.img);
              },
              render : function(){
                
              },
};
export default {
  name: 'NakedMain',
  components:{
  },
  props: {
  },
  head: {
    meta: function () {
      return [
        { property: "og:title", content: this.$t("LP.ogp.title") },
        { property: "og:description", content: this.$t("LP.ogp.description") },
        { property: "og:type", content: this.$t("LP.ogp.type") },
        { property: "og:url", content: this.$t("LP.ogp.url") },
        { property: "og:site_name", content: this.$t("LP.ogp.site_name") },
        {
          property: "og:image",
          content: location.origin + this.$t("LP.ogp.image"),
        },
        { name: "twitter:card", content: this.$t("LP.ogp.twitter_card") },
      ];
    },
  },
  data: () => ({  
    lgs:[{name:'日本語',type:'jp'},{name:'English',type:'en'},{name:'Français',type:'fr'},{name:'简体中文',type:'cn'},{name:'한국어',type:'kr'},{name:'繁體中文',type:'tw'}],
    lgIndex:0,
    showLg:false,
    autoPlay:true,
    scroll:null,
    palceIndex:0,
    watageNum:0,
    moneyType:0,
    needHide:false,
    totalNumber:0,
    nextTimeStamp:0,
    isOpend:false,
    navstatus:0,
    observer:null,
    isDown:false,
    backgroundImg:'/Images/bg/dp_lp_pc_bg_1.jpg',
    backgroundImg1:'/Images/bg/dp_lp_pc_bg_1.jpg',
    backgroundImg2:'/Images/bg/dp_lp_pc_bg_2.jpg',
    backgroundImg3:'/Images/bg/dp_lp_pc_bg_3.jpg',
    backgroundImg1PC:'/Images/bg/dp_lp_pc_bg_1_pc.jpg',
    backgroundImg2PC:'/Images/bg/dp_lp_pc_bg_2_pc.jpg',
    backgroundImg3PC:'/Images/bg/dp_lp_pc_bg_3_pc.jpg',
    watateResBgUrl:"/Images/watage_res/watage_res_0.gif",
    btn_url:"/Images/button_name1_s.png",
    playerNames:[],
    touch:{},
    isScrolled:false,
    timeRequestTotoalFunc:null,
    isFetching:false,
    watageList:[],
    latestPlayerList:[],
    // モーダルの管理用
    // いったん以下は使わない
    //windowWidth: window.innerWidth+'px',

    // PCとモバイルを切り替えるためのもの、消さないように
    isMobile,
    // isMobileDevice: function () {
    //   // if (isMobile().any) {
    //   //   return true;
    //   // }
    //   // return false;
    //   return window.innerWidth<800;
    // },
    autoNextPlaceFunc:null,
    autoNextPlacewaitFunc:null,
    placeWidth:0,
    priceNumber:"",
    showSafariTips:false,
    placeClickIndex:0,
    placeClicked:false,

  }),
  mounted() {
    this.updateHeadData();
    this.initEvent();
    var self = this;
    this.$nextTick(()=>{
      self.initScoll();
    })
  },
  destroyed(){
    if(this.observer){
      this.observer.disconnect();
    }
    if(this.timeRequestTotoalFunc){
      clearInterval(this.timeRequestTotoalFunc);
    }
  },
 computed: {

      safariUrl:function(){
         switch(this.lgIndex){
          case 0:
            return '../Images/safari_tips_jp.png';
          case 1:
            return '../Images/safari_tips_en.png';
          case 2:
            return '../Images/safari_tips_fr.png';
          case 3:
            return '../Images/safari_tips_cn.png';
          case 4:
            return '../Images/safari_tips_kr.png';
          case 5:
            return '../Images/safari_tips_tw.png';
        }
            return '../Images/safari_tips_jp.png';
      },
     titleUrl:function(){
         switch(this.lgIndex){
          case 0:
            return '../Images/dp_lp_pc_copy.png';
          case 1:
            return '../Images/dp_lp_pc_copy.png';
          case 2:
            return '../Images/dp_lp_pc_fr_copy.png';
          case 3:
            return '../Images/dp_lp_pc_cn_copy.png';
          case 4:
            return '../Images/dp_lp_pc_kr_copy.png';
          case 5:
            return '../Images/dp_lp_pc_tw_copy.png';
        }
        return '../Images/dp_lp_pc_copy.png';
      },
    winHeight() {
      return window.innerHeight +'px'
    },
     webImgHeight() {
      return window.innerHeight*0.8 +'px'
    },
    isMobileDevice () {
      // if (isMobile().any) {
      //   return true;
      // }
      // return false;
      return window.innerWidth<800;
    },
      currentFont:function()
      {
        switch(this.lgIndex){
          case 0:
            return 'font-Regular-jp';
          case 1:
            return 'font-Regular-en';
          case 2:
            return 'font-Regular-en';
          case 3:
            return 'font-Regular-cn';
          case 4:
            return 'font-Regular-kr';
          case 5:
            return 'font-Regular-tw';
        }

            return 'font-Regular-jp';
      },
      currentBoldFont:function()
      {
        switch(this.lgIndex){
          case 0:
            return 'font-Bold-jp';
          case 1:
            return 'font-Bold-en';
          case 2:
            return 'font-Bold-en';
          case 3:
            return 'font-Bold-cn';
          case 4:
            return 'font-Bold-kr';
          case 5:
            return 'font-Bold-tw';
        }
            return 'font-Bold-jp';
      },
       currentMediumFont:function()
      {
        switch(this.lgIndex){
          case 0:
            return 'font-Medium-jp';
          case 1:
            return 'font-Medium-en';
          case 2:
            return 'font-Medium-en';
          case 3:
            return 'font-Medium-cn';
          case 4:
            return 'font-Medium-kr';
          case 5:
            return 'font-Medium-tw';
        }
            return 'font-Medium-jp';
      }
     
     
  },

  methods: {
    getUrlArgs(){
        var url = window.location.href ;
        var dz_url = url.split('#')[0];
        var cs = dz_url.split('?')[1];
        if(cs){

        var cs_arr = cs.split('&');
        var args={};
        for(var i=0;i<cs_arr.length;i++){
          args[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
          }
          if(args.goto)
          {
            this.goAnchor(args.goto);
          }
        }
      },
    onClickPlace(url){
      this.outPlace();
      window.open(url,"_blank");
    },
    setSliderWidth() {
      this.children = this.$refs.placeScrollContent.children
      //width: the width of sliderGroup(content)
      //sliderWidth: the width of slider(wrapper)
      let width = 0
      let sliderWidth = this.placeWidth = this.$refs.placeScroll.clientWidth
      for(let i=0; i<this.children.length; i++) {
        let child = this.children[i]
        child.style.width = sliderWidth + 'px'
        width += sliderWidth
      }
      //
      if(this.loop) {
        width += 2 * sliderWidth
      }
      this.$refs.placeScrollContent.style.width = width + 'px'
      this.scroll.refresh();
      
    },
    initScoll()
    {
      if(this.isMobileDevice){
        if(!this.scroll)
            {
              this.scroll = new BScroll(this.$refs.placeScroll,{
                startX:0,
                click:true,
                scrollX:true,
                scrollY:false,
                eventPassthrough:true
              
              })
              this.setSliderWidth();
            }else{
              this.scroll.refresh();
            }
      }
    
    },
    enterPlace(){
      this.autoPlay = false;
    },
    outPlace(){
      
      this.autoPlay = true;
     
     
    },
      createWatage(){
        var index = this.watageList.length;
        var curData = this.latestPlayerList[index];
       this.watageList.push(new Watege(curData.watageColor?curData.watageColor:1,curData.watageShape?curData.watageShape:0,curData.firstName,curData.lastName,!this.isMobileDevice));
            // this.watageList.push(new Watege(1,1,"test","test",!this.isMobileDevice));
     
     },
     initWatage(num)
     {
       for(var j in this.watageList)
       {
         this.watageList[j].destroyFunc();
       }
       this.watageList.splice(0);
        this.watageNum= Math.floor(num/1000);
        var curTotal = num % 1000;
        var curStep =Math.floor(curTotal/50);
        var curNum = curTotal%50;
        this.watateResBgUrl = 'Images/watage_res/watage_res_'+curStep+'.gif';
        var self = this;
        for(var i =0;i< curNum;i++){
          
          setTimeout(() => {
            self.createWatage();
          }, 100*i);
        }
        
     },
    mouseWheelResult(ev)
    {
      
      ev.preventDefault();
      if(this.$refs.my_scroller.scroller.__maxScrollTop <= this.$refs.my_scroller.getPosition().top && !this.isFetching)
      {
        this.infinite();
      }
       if(ev.deltaY>0)
       {
            this.$refs.my_scroller && this.$refs.my_scroller.scrollBy(0,30,false);
       }else{

            this.$refs.my_scroller && this.$refs.my_scroller.scrollBy(0,-30,false);
       }
    },
        mouseWheel(ev)
      {
        if(ev.deltaY > 0)
        {
          this.isScrolled = true;
        }
      },
      touchStart(ev)
      {
        this.touch.x1 = ev.changedTouches[0].pageX;
        this.touch.y1 = ev.changedTouches[0].pageY;
      },
     
      touchEnd(ev)
      {
          this.touch.x2 = ev.changedTouches[0].pageX;
          this.touch.y2 = ev.changedTouches[0].pageY;
          let h = Math.abs(this.touch.y1 - this.touch.y2);
          if(h > 1)
          {
            if(this.touch.y2 < this.touch.y1){
            
                  this.isScrolled = true;
            }
          }
      },
    infinite(){
      var self = this;
      self.isFetching = true;
      if(self.nextTimeStamp == 1){
        
        self.isFetching = false;
        self.$refs.my_scroller.finishPullToRefresh();
        self.$refs.my_scroller.finishInfinite(true);
        return;
      }
      netMgr.RequestPlayerList( self.nextTimeStamp ==0?Date.now(): self.nextTimeStamp ,(data)=>{
      
        self.isFetching = false;
        self.$refs.my_scroller.finishPullToRefresh();
        self.$refs.my_scroller.finishInfinite(true);
        if(data!=null){
             if(!data.code){
                   
                                if(data.players)
                                {
                                      self.nextTimeStamp = data.nextTimeStamp;
                                      data.players.forEach(element => {
                                      
                                        self.playerNames.push(element);
                                      }
                                    
                                )
                              }
             }else{
              //  done();
             }
          
        
        }else{
          // done(false)
        }
        });
    },
    changeSlide(i)
    {

      this.enterPlace();
        if(this.scroll)
        {
          this.scroll.stop();
          var near = Math.ceil(Math.abs(this.scroll.x)/this.placeWidth);
          
          this.palceIndex = near;
           this.palceIndex +=i;
          if(this.palceIndex > (this.$t('LP.place').length*2-1)){

            this.palceIndex = (this.$t('LP.place').length -1);
              var x = this.placeWidth * -this.palceIndex;
             this.scroll.scrollTo(x,0,0);
          }
          if(this.palceIndex <0){
            this.palceIndex = (this.$t('LP.place').length -1);
               x = this.placeWidth * -((this.$t('LP.place').length ));
             this.scroll.scrollTo(x,0,0);
          }

          this.scroll.scrollTo(this.placeWidth * -this.palceIndex,0,1000);
        }
       setTimeout(() => {
          self.outPlace();
        }, 2000);
    },
    onClickContact(){
      window.open("https://naked.co.jp/contact/","_blank");
    },

    onClickPlay(){
      window.open("https://play.dandelionpj.com","_blank");
      
      //window.open("http://bbpv2-play-test.s3-website-ap-northeast-1.amazonaws.com/","_blank");
    },
    
 formatValue(e){
   
e.target.value =e.target.value.replace(/[\uFF00-\uFFFF]/g,function(m){
    var charCode = m.charCodeAt(0);
    if(charCode>=65296 || charCode<=65305)
    {
        return String.fromCharCode(charCode-65248);
    }});

                //过滤e字符
      e.target.value = e.target.value.replace("e", "");
      
      //判断输入是数字和.
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      
      // 保证.只出现一次，而不能出现两次以上
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.priceNumber = e.target.value;
     
      // 必须保证第一个为数字而不是.
      this.priceNumber = this.priceNumber.replace(/^\./g, "0.");
      
      // 保证只有出现一个.而没有多个.
      this.priceNumber = this.priceNumber.replace(/\.{2,}/g, ".");


      //只能输入两个小数
      this.priceNumber = this.priceNumber.replace(/^()*(\d+)\.(\d\d).*$/, "$1$2.$3");
            },
     onClickCtr1(){
      // if(this.priceNumber && parseInt( this.priceNumber)>99){
      //           netMgr.RequestCreatePayment(this.priceNumber,this.lgIndex==0?'jpy':'usd',(data)=>{
                 
      //                 if(data!=null)
      //                 {
      //                 // this.isPaying = true;     
      //                 // console.log(window.location.origin+"/checkout.html?clientSecret="+data.clientSecret)
      //                     window.open(window.location.origin+"/checkout.html?clientSecret="+data.clientSecret,"_blank")
      //                   // this.initSprite(data.clientSecret);
      //                 }
      //           })
      // }
     
      //  if(this.$t('content.ctr.pay_urls')[this.moneyType]){

      //       window.open(this.$t('content.ctr.pay_urls')[this.moneyType].url,"_blank");
      //   }
       if(this.moneyType==4){
        if(this.priceNumber ){
                      netMgr.RequestCreatePayment(this.priceNumber,this.lgIndex==0?'jpy':'cent',(data)=>{
                            
                            if(data!=null)
                            {
                              this.priceNumber = "";
                                window.open(window.location.origin+"/checkout.html?clientSecret="+data.clientSecret,"_blank")
                            }
                      })
            }
     }else{
        if(this.$t('LP.ctr.pay_urls')[this.moneyType]){

            window.open(this.$t('LP.ctr.pay_urls')[this.moneyType].url,"_blank");
        }
     
     }

    },
    onClickCtr2(){
      window.open('https://camp-fire.jp/projects/view/314807',"_blank");
    },
      goAnchor(id){
        this.closeNav();
          var anchor = this.$el.querySelector("#"+id);
           if(anchor!=null||anchor!=undefined){

              // chrome
               document.body.scrollTop = anchor.offsetTop;
              // firefox
             document.documentElement.scrollTop = anchor.offsetTop;
          }
      },
      showNav()
      {
        this.navstatus = 1;
        document.documentElement.style.overflow='hidden';
      },
    closeNav()
    {
      if(this.navstatus == 1){

        this.navstatus = 2;
        document.documentElement.style.overflow='auto';
      }

    },
    onClickDown(){
      this.isDown = !this.isDown;
    },
    window: (onload = function () {
      //ページ読み込み時にCookieに言語設定を保存
      document.cookie =
        "lang=" + "jp" + "; expires=Thu, 1-Jan-2030 00:00:00 GMT; domain=.breathbless.com; path:/";
    }),
    slideshow(images) {
      const current = images[this.index];
      const prev = images[this.index - 1]
        ? images[this.index - 1]
        : images[images.length - 1];
      current.classList.add("fadein");
      current.classList.remove("fadeout");
      prev.classList.remove("fadein");
      prev.classList.add("fadeout");
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;

      // 合わせてヘッダも更新する
      //this.$emit('updateHead');
      this.updateHeadData();
    },
    save(e) {
      //言語切り替えボタンを押したときにCookieの言語設定情報を更新
      document.cookie = "lang=" + e + "; expires=Thu, 1-Jan-2030 00:00:00 GMT; domain=.breathbless.com; path:/";
    },
    updateHeadData() {
      document.title =
        this.$t("LP.ogp.title") + " | " + this.$t("LP.ogp.description");
      document
        .querySelector("meta[property='og:title']")
        .setAttribute("content", this.$t("LP.ogp.title"));
      document
        .querySelector("meta[property='og:description']")
        .setAttribute("content", this.$t("LP.ogp.description"));
      document
        .querySelector("meta[property='og:type']")
        .setAttribute("content", this.$t("LP.ogp.type"));
      document
        .querySelector("meta[property='og:url']")
        .setAttribute("content", this.$t("LP.ogp.url"));
      document
        .querySelector("meta[property='og:site_name']")
        .setAttribute("content", this.$t("LP.ogp.site_name"));
      document
        .querySelector("meta[property='og:image']")
        .setAttribute("content", location.origin + this.$t("LP.ogp.image"));
      document
        .querySelector("meta[name='twitter:card']")
        .setAttribute("content", this.$t("LP.ogp.twitter_card"));
    },
    setCookie(name, value) {
         if(name=='lang'){

             document.cookie = name + "=" + encodeURI(value) + ";expires=Thu, 1-Jan-2030 00:00:00 GMT; domain=.breathbless.com;path:/";
         }else
         {
             document.cookie = name + "=" + encodeURI(value) + ";expires=Thu, 1-Jan-2030 00:00:00 GMT;path:/";
         }
    },
       onClickLg(_index)
      {
        this.showLg =false;
        this.lgIndex = _index;
        this.$i18n.locale = this.lgs[_index].type;
        this.setCookie('lang',this.lgs[_index].type);
      },
      requestTotalNumber()
      {
        var self = this;
          netMgr.RequestTotalPlayer((data)=>{
            if(data!=null){

            if(data.total)
              self.totalNumber = data.total;

            }
          });
      },
      requestLatestGroup(){
        var self = this;
        netMgr.RequestLatestGroup((data)=>{
            if(data!=null){
              self.latestPlayerList = data.players;
              self.initWatage(data.newTotal);
            }
        });
      },
      onClickPlaceIndex(index){
        this.placeClickIndex = index;
        this.placeClicked = true;
      },

      onClickPlaceClosed(){
        this.placeClicked = false;
      },
      initEvent()
      {
        var self = this;
        window.onload = function(){

          self.getUrlArgs()
        }
      if(this.isMobileDevice){
        this.autoNextPlaceFunc  = requestAnimationFrame(function fn(){
                      if(self.autoPlay){
                          var x = self.scroll.x - 1;
                              if(x<=self.scroll.maxScrollX){
                                x = self.scroll.maxScrollX/2+self.placeWidth/2;
                              self.scroll.scrollTo(x,0,0);
                              self.scroll.scrollTo(x-1,0,0);
                              }else{
                              self.scroll.scrollTo(x,0,0);

                              }
                      }
                          
                      requestAnimationFrame(fn);
                  });
        
            }
        // self.initWatage(1149);
        self.$t('LP.result.names').forEach(element => {
          
            self.playerNames.push(element);
        });
        self.timeRequestTotoalFunc = setInterval(()=>{
          self.requestTotalNumber();
          self.requestLatestGroup();
        },60000);
        self.requestTotalNumber();
        self.requestLatestGroup();
        self.observer = new IntersectionObserver(changes => {
          for (const change of changes) {
            if(change.target.id == "element_bg_B" || change.target.id == "element_bg_B1")
            {
              if(change.intersectionRatio >0 )
                  self.backgroundImg =  self.isMobileDevice?self.backgroundImg2:self.backgroundImg2PC;
            }else if(change.target.id == "element_bg_C"){
              if(change.intersectionRatio >0 ) 
                self.backgroundImg =  self.isMobileDevice?self.backgroundImg3:self.backgroundImg3PC;
            }else{
              if(change.intersectionRatio >0 )
                self.backgroundImg = self.isMobileDevice?self.backgroundImg1:self.backgroundImg1PC;
            }
              

          }
      }, {});
         self.observer.observe(document.getElementById('element_bg_A'));
         self.observer.observe(document.getElementById('element_bg_B'));
         self.observer.observe(document.getElementById('element_bg_B1'));
         self.observer.observe(document.getElementById('element_bg_C'));
      }
  },
}
</script>

<style scoped>

#main{
    width: 100%;
    margin: auto;
    text-align: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size:cover;
    -webkit-background-size: cover !important; 
    -moz-background-size: cover !important; 
    -o-background-size: cover; 
    background-attachment:fixed;
    background-position: -99999px -99999px;
    /* position: relative; */
    color: rgb(70, 70, 70);
}
    #main:before{
        content: "";
        position: fixed;
        top: 0;
        right: 0;
        height: 100%;
        width: 100%;
        background-image: inherit;
    background-position: center;
    background-repeat: no-repeat;
    background-size:cover;
    -webkit-background-size: cover !important; 
    -moz-background-size: cover !important; 
    -o-background-size: cover; 

    }
.bg-color{
    background-color: #f8f7f2;
}
.bg-color-85{

    background-color: #f8f7f2df;
}
.bg-color-yellow{

    background-color: rgb(246, 218, 100);
}
.font-Regular-cn{
    font-family: 'cnFont';
    font-weight: 400;
    font-style: normal;
}
.font-Bold-cn{
    font-family: 'cnFont';
    font-weight: 700;
    font-style: normal;
}
.font-Medium-tw{
    font-family: 'twFont';
    font-weight: 500;
    font-style: normal;
}
.font-Regular-tw{
    font-family: 'twFont';
    font-weight: 400;
    font-style: normal;
}
.font-Bold-tw{
    font-family: 'twFont_bold';
    font-weight: 700;
    font-style: normal;
}
.font-Medium-cn{
    font-family: 'cnFont';
    font-weight: 500;
    font-style: normal;
}
.font-Regular-kr{
    font-family: 'krFont';
    font-weight: 400;
    font-style: normal;
}
.font-Bold-kr{
    font-family: 'krFont';
    font-weight: 700;
    font-style: normal;
}
.font-Medium-kr{
    font-family: 'krFont';
    font-weight: 500;
    font-style: normal;
}
.font-Regular-jp{

    font-family:'Noto Sans Japanese', sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .font-Medium-jp{

    font-family:'Noto Sans Japanese', sans-serif;
    font-weight: 500;
    font-style: normal;
  }
  .font-Bold-jp{

    font-family:'Noto Sans Japanese', sans-serif;
    font-weight: 700;
    font-style: normal;
  }
  .font-Regular-en{

    font-family:"sofia-pro", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .font-Bold-Italic-en{

    font-family:"sofia-pro", sans-serif;
    font-weight: 500;
    font-style: normal;
    font-style: italic;
  }
  .font-Bold-en{

    font-family:"sofia-pro", sans-serif;
    font-weight: 700;
    font-style: normal;
  }
  .top-right{
     position: absolute;
     top:30px;
     right:10px;
        display: inline-flex;
    /*width: 7%;*/
  }
  .label{
    cursor: pointer;
     margin-left: 25px;
    
  }
    .input-frame{
    position: relative;
    width: 100%;

  }
   .input-frame img{
    width: 100%;

  }
  .top-right img{
    width: 1.8rem;
    height: 1.8rem;
    margin: auto;
    margin-left: 20px;

  }
  .activeStyle{
    opacity: 0.5;
  }
.full-width{
    width: 100%;

    margin: auto;
    text-align: center;
}
.pos-relative{
  position: relative;
}
.pos-absolute{
  position: absolute;
}
.logo-bg{

    max-width: 700px;
}
.logo-bg-mb{
    opacity: 0;
}
.logo-mb{
    position: absolute;
    width: 85%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    opacity: 0;
    max-width: 600px;
}

  .line{
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%,0%);
    width: 2px;
    animation: moveto 2s linear 0s infinite normal forwards;
  }
  @keyframes moveto {
    0% {height: 0px;top: 0;}
    50% {height: 2rem;top:0;}
    100% {height: 0px;top:2rem;}
  }
  @-webkit-keyframes moveto{/*针对webkit内核*/
    0% {height: 0px;top: 0px;}
    50% {height: 2rem;top:0;}
    100% {height: 0px;top:2rem;}
  }
  .div-sroll{
      text-align: center;
      font-size: 3rem;
  }
   .fade-in-ani{
    opacity: 0;
    animation:fade-in 1.5s linear 0s 1 normal forwards;
  }
  @keyframes fade-in {
    0% {opacity: 0;}/*初始状态 透明度为0*/
    100% {opacity: 1;}/*结束状态 透明度为1*/
  }
  @-webkit-keyframes fade-in {/*针对webkit内核*/
    0% {opacity: 0;}/*初始状态 透明度为0*/
    100% {opacity: 1;}/*结束状态 透明度为1*/
  }
  .fade-in-ani-delay{
    opacity: 0;
    animation:fade-in 1.5s linear 1.5s 1 normal forwards;
  }
   .fade-in-ani-delay2{
    opacity: 0;
    animation:fade-in 1.5s linear 3s 1 normal forwards;
  }
  .p-desc{
    margin: auto;
    width: 90%;
    word-wrap:break-word;
    text-align: center;
    white-space: pre-wrap;
    font-size: 1.125rem;
    line-height: 2.5rem;
  }
  .sticky {
  position: fixed;
  z-index: -1;
  top: 0;
  width: 100%;
  background: chartreuse;
    }
.opacity-85{
    opacity: 0.85;
}
.empty{
    width: 100%;
}
.title{
    font-size: 10vw;
}
.bg-img{
    width: 100%;
    background-position: center;
    background-size: cover;
 }
  .input-btn{
    margin: auto;
    position: relative;
    width: 50%;
    max-width: 300px;
  }
  .input-btn img{
    width: 100%;
  }
  .input-btn span{ 
    position: absolute;
    top: 50%;
    font-size: 1.5rem;  
    left: 50%;
    transform: translate(-50%,-50%);
    pointer-events: none;
  }
  .input-btn :active{
    position: relative;
    top: 1px;
    transform: scale(0.9);
    -webkit-transform: scale(0.9);
  }
  .a-support{
      color: black;
      font-size: 2rem;
      letter-spacing: 2px;
  }
  .div-scroll{
      width: 100%;
      overflow: hidden;
      margin: auto;
  }
  .box-y{
    padding: 10px 0;
    white-space: nowrap;/*文本不会换行，文本会在在同一行上继续*/
    overflow-y:auto;/*可滑动*/
}
.box-y ::-webkit-scrollbar {
        display: none;
    }
  .box-x{
    padding: 10px 0;
    white-space: nowrap;/*文本不会换行，文本会在在同一行上继续*/
    /* overflow:auto; */
    width: 90%;
    /* height: 200px; */
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    align-content:flex-start;

    justify-content:flex-start;
}
/*自定义滚动条的伪对象选择器, CSS 可以隐藏滚动条*/
/*.box::-webkit-scrollbar{
    display: none;
}*/
.box1{
    width:80%;
    margin: 3%;
    /* height: 100px; */
    display: inline-block;/*行内块元素*/
}
.box2{
  font-size: 1rem;
  padding-left: 1rem;
    /* width:15%; */
    height:1.5rem;
    display: block;/*行内块元素*/
}
.text-left{
  text-align: left;
  margin-left: 5%;
}
 .form-input{
    max-width:150px;
    /* margin:auto; */
    height:24px;
    
      outline:0;
      text-align: left;
    background-color: #fef1b2;
    border: none;
  }
.down-div{
  display: flex;
  margin:auto;
  position: relative;
    
}
.down-div img{
  margin: auto;
  margin-left: 30px;
  width: 2rem;
  height: 1rem;
  /* width: 50px;
  height: 25px; */
  /* position: relative; */
  /* top: 50%;
  transform: translateY(-50%); */
}
.num-div{
   margin: auto;
    position: relative;
    width: 70%;
    max-width: 400px;
  }
  .num-div img{
    width: 100%;
  }
  .num-div span{ 
    position: absolute;
    top: 45%;
    font-size: 2rem;  
    left: 50%;
    transform: translate(-50%,-50%);
    pointer-events: none;
  }
  .supporters-div{
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    margin: auto;
    max-width: 800px;
    /* width:90% */
    
  }
   /* .supporters-div::after{
      content: "";
    max-width: 120px; 
   
       flex: auto; 
    }  */
  .supporters-item{
    max-width: 120px;
    
  }
  .support-img{
    width: 80%;
    position: relative;
    top: 50%;
    left:50%;
    transform: translate(-50%,-50%);
  }
  .icon-div{
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    max-width: 250px;

  }
   .icon-div a{
     /* padding-left: 2rem; */
  }
  .icon-div img{
    width:30px;
  }
  .footer{
    display: block;
    font-size: 1rem;
  }
   .pop{

        background: rgba(0, 0, 0, 0.90);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 101%;
        z-index: 11;
        overflow: auto;
    }
    .navmove{

        animation: navmove 0.7s linear 0s 1 normal forwards;
    }
     .navmoveback{

        animation: navmove2 0.7s linear 0s 1 normal forwards;
    }
       @keyframes navmove {
    0% {left: 100%;}
    100% {left: 0%;}
  }
  @-webkit-keyframes navmove {/*针对webkit内核*/
    0% {left: 100%;}
    100% {left: 0%;}
  }
    @keyframes navmove2 {
    0% {left: 0%;}
    100% {left: 100%;}
  }
  @-webkit-keyframes navmove2 {/*针对webkit内核*/
    0% {left: 0%;}
    100% {left: 100%;}
  }
    .nav-logo{
      width: 70%;
    }
    .nav-close{
      width: 5%;
      position: absolute;
      top:5%;
      right: 5%;
    }
    .nav-ul{
      list-style:none;
      width: 80%;
      margin-left: 5%;
    }
    .nav-ul li{
      width:100%;
      
      list-style:none;
      margin-top: 0.5rem;
      text-align: left;
      color: white;
    }
     .nav-ul li :active{
       background-color: white;
      color: black;
    }
    .nav-ul p{
      width: 100%;
      text-decoration: none;
      font-size: 1.125rem;
    }
    .icon-nav{
      width: 100%;
      margin-top: 5%;
      margin-left: 10%;
      display:flex;
      justify-content: left;
      max-width: 300px;

  }
   .icon-nav a{
     padding-right:1.5rem;
  }
  .icon-nav img{
    width:30px;
  }
  .my-carousel{
    width: 100%;
  
  }
  .my-carousel ul{
    padding-left: 0% !important;
  }
  .slide-item{
    width: 90%;
    margin-bottom: 20px;
  }
  .slide-item-mb{
    width: 100%;
  }
  .slide-item-mb img{
    width: 100%;
  }
  .slide-item img{
    width: 100%;
  }
.button-prev {
  width: 20px;
  position: absolute;
  left: 10%;
  top: 30%;
  transform: translateY(-50%);
}
.button-next {
  width: 20px;
  position: absolute;
  right: 10%;
  top: 30%;
  transform: translateY(-50%);
}
.max-width{
  max-width: 700px;
  margin: auto;
}
.font-title
{
  font-size: 1.95rem;
    word-wrap:break-word;
    white-space: pre-wrap;
}
.font-desc
{
  font-size: 1.125rem;
    word-wrap:break-word;
    white-space: pre-wrap;
}
.place-div{
  display: flex;
  flex-wrap: wrap;
  width:70%;
  /* max-width: 800px; */
  margin: auto;
}
.place-div-mb{
  display: flex;
  flex-wrap: wrap;
  width:95%;
  justify-content: flex-start;
  /* max-width: 800px; */
  margin: auto;
}
.effect-blur{

  filter: blur(5px);
}
.place-div-item{
  width: 33.3%;
}
.place-div-item-mb{
  width: 29.3%;
  margin: 2%;
}
.art-div{
  widows: 100%;
  max-width: 1200px;
  display: flex;
  margin: auto;
  font-size: 1rem;
}
.art-div p{
  font-size: 1.2rem;
}
.mb-font-title{

  font-size: 1.625rem;
    word-wrap:break-word;
    white-space: pre-wrap;
}
.mb-font-desc{

  font-size: 1rem;
    word-wrap:break-word;
    white-space: pre-wrap;
    line-height: 1.8rem;
}
.mb-font-desc-s{

    word-wrap:break-word;
    white-space: pre-wrap;
  font-size: 0.85rem;
    line-height: 1.5rem;
}
.input-btn .mb-font-desc{

  font-size: 1.2rem;
}
.vs-carousel >>> .vs-carousel__wrapper{
    padding-left: 0% !important;
}
.letter-spacing-title{
  letter-spacing:2px;
}
.div-scroll-name{
  position: relative;
  width: 100%;
  height: 200px;
}
.opacity-0{
  opacity: 0;
}
.radio-div{
  display:  inline-block;
  margin:auto 0;
}
input[type=radio]:after{
  color: black;
}
#flower-div{
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%,-50%);
  overflow: hidden;
  width: 100%;
  /* max-width: 600px; */
  height:900px;
  margin: auto;
}
.flower-gif{
  width: 80%;
  max-width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 2;
}
.flower-count{
  width: 100%;
 /* position: absolute;
  top: -3%;
  right: 0%; */
  display:flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
}
.flower-count img{
  /* position: absolute; */
  width: 50px;
   /* animation: ani 2s linear 0s 1 normal forwards; */
}
 @keyframes ani {
    0% {opacity: 0;
        position: absolute;}/*初始状态 透明度为0*/
    100% {opacity: 1;
    position: relative;}/*结束状态 透明度为1*/
  }
  @-webkit-keyframes ani {/*针对webkit内核*/
    0% {opacity: 0;}/*初始状态 透明度为0*/
    100% {opacity: 1;}/*结束状态 透明度为1*/
  }

.placeWrapper{
  overflow: hidden;
}
.tags {
  white-space: nowrap;
  /* display: flex; */
  /* overflow: hidden; */

  /* width: 100%; */
}
/* .tags::-webkit-scrollbar {
  display: none;
} */

  .tag {
  display: inline-block; 
  flex-direction: column;
  align-items: center;
  vertical-align: top;
  /* width: 90%; */
  padding: 0 30px;

  /* white-space: normal; */
}
.tag img{
  width: 100%;
}
.tag h4{
  width: 100%;
  word-wrap: normal;

    white-space: pre-wrap;
}
.slide-item-p{
  margin:0;
  width: 100%;
}
.slide-item-a{
  color: rgb(70, 70, 70);
}
 .lg-div
  {
    position: relative;
    width: 110px;
  }
.lg-div input {
    opacity:0;
    position:absolute;
    left:-99999px;
  }

  .lg-div input:checked + label {
    order: 1;
    z-index:2;
    background: #f8f7f2;
    border-top:black solid 1px;
    position:relative;

  }
.zq-drop-list-new{
    display: inline-block;
    width: 110px;
    position: relative;
    border: solid 2px black;
    box-sizing: border-box;
    z-index: 10;
  }
  .zq-drop-list-new span{
    display: block;
    height: 1.8rem;
    line-height: 1.8rem;
    /*font-size: 14px;*/
    text-align: center;
    /* background-size: 1rem ; */
    background-color: #f8f7f2;
  }
  .zq-drop-list-new ul{
    background: #f8f7f2;
    position: absolute;
    top: 1.8rem;
    left:-2px;
    width: 110px;
    margin: 0;
    padding: 0;
    /*box-sizing: border-box;*/
    border: solid 2px rgb(138, 136, 136);
    border-top: solid 2px rgb(0, 0, 0);
    /*border: solid 1px #f1f1f1;*/
    /*border-radius: 4px;*/
    overflow: hidden;
  }
  .zq-drop-list-new li{
    
    text-align: center;
    list-style: none;
    height: 1.8rem;
    line-height: 1.8rem;
    background: #f8f7f2;
  }
  .zq-drop-list-new li:hover{
    background: #d8d7d7;
  }
  .zq-drop-list-new .chossLi{
    background: #d8d7d7;
  }
  .triangle-down {
    position: absolute;
    top:35%;
    right: 8%;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid rgb(138, 136, 136);
}
.popupdiv{
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  width:100%;
  transform: translate(-50%,-50%);
  
}
</style>
